export namespace INVOICE_STATUS {
    export const SENT = "sent"
    export const PARTIALLY_PAID = "partially-paid"
    export const FULLY_PAID = "fully-paid"

}

export type INVOICE_STATUS = typeof INVOICE_STATUS[keyof typeof INVOICE_STATUS]


// WEBPACK FOOTER //
// ./src/state/invoice/InvoiceStatus.ts